// import axiosInstance from '../interceptors/tokenInterceptor';
import axios from "axios";

export const getProducts = async (filters = {}) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/get-products`, filters);
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const getSingleProduct = async (uid) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-product/${uid}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching single product:', error);
    throw error;
  }
};
